import { StatModule } from "@/core/modules/stat/objects/StatModule";

import CompanyStorageView from "./views/CompanyStorageView.vue";

export const companyStorage: StatModule = new StatModule("warehouse", "CompanyStorage", "warehouseStat", CompanyStorageView);
